export enum FieldType {
  Group = 'Group',
  Textbox = 'textbox',
  Textarea = 'textarea',
  Checkbox = 'checkbox',
  Combobox = 'combobox',
  Radio = 'radio',
  BranchList = 'pobocky',
  Attachment = 'priloha',
  Step = 'step'
}

export enum FieldDirection {
  Input = 'Vstupni',
  Text = 'Text',
  Output = 'Vystupni'
}

export enum CreateDataCodes {
  Ok = 'OK',
  Error = 'ERR'
}

export enum ValidationErrorType {
  TooLong = 'maxlength',
  TooShort = 'minlength',
  ValueMissing = 'required',
  PatternUnmatch = 'invalid.format',
  AccPrefix = 'invalid.prefix',
  FileSize = 'attachment.maxSizeExceeded',
  FileName = 'attachment.fileName',
  FileType = 'attachment.invalidExtension',
  InvalidAccountNumber = 'invalid.wrong-account-format',
  BankCode = 'invalid.bankCode',
  PersonalId = 'invalid.birthNumber.modulo'
}

export enum ValidationType {
  Phone = 'tel.cislo',
  AccountNumber = 'ucet',
  Date = 'datum',
  Email = 'email',
  Number = 'cislo',
  ZipCode = 'PSC',
  PhoneEnha = 'tel.Bez1/8',
  PersonalId = 'rodnecislo'
}
